/* Flick Hockey — revelado suave al hacer scroll. Respeta prefers-reduced-motion. */
(function () {
  function init() {
    var els = document.querySelectorAll('.fk-rv:not(.fk-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (e) { e.classList.add('fk-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('fk-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e, i) {
      e.style.transitionDelay = (Math.min(i, 4) * 55) + 'ms';
      io.observe(e);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // el editor de Shopify recarga secciones sin recargar la página
  document.addEventListener('shopify:section:load', init);
})();

/* Menú móvil (drawer) — accesible: Esc, foco y bloqueo de scroll */
(function () {
  function initDrawer() {
    var d = document.getElementById('fk-drawer');
    if (!d || d.dataset.fkReady) return;
    d.dataset.fkReady = '1';
    var opener = document.querySelector('[data-fk-open]');
    function open() {
      d.classList.add('fk-open');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = d.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      d.classList.remove('fk-open');
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
      document.body.style.overflow = '';
    }
    if (opener) opener.addEventListener('click', open);
    d.querySelectorAll('[data-fk-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.classList.contains('fk-open')) close();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDrawer);
  else initDrawer();
  document.addEventListener('shopify:section:load', initDrawer);
})();

/* Cabecera transparente sobre el hero: se vuelve sólida al hacer scroll */
(function () {
  function initHdr() {
    var h = document.querySelector('.fk-hdr-over');
    if (!h || h.dataset.fkScroll) return;
    h.dataset.fkScroll = '1';
    var on = function () { h.classList.toggle('fk-solid', window.scrollY > 40); };
    window.addEventListener('scroll', on, { passive: true });
    on();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHdr);
  else initHdr();
  document.addEventListener('shopify:section:load', initHdr);
})();

/* Cabecera fija: el sticky va en el contenedor de la sección y se desplaza
   hacia arriba el alto del topbar, para que este se vaya al hacer scroll
   y la cabecera quede clavada arriba. */
(function () {
  function pin() {
    var sec = document.querySelector('.fk-hdr-sec');
    if (!sec) return;
    var top = sec.querySelector('.fk-top');
    sec.style.top = top ? (-top.offsetHeight) + 'px' : '0px';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pin);
  else pin();
  window.addEventListener('resize', pin);
  document.addEventListener('shopify:section:load', pin);
})();

/* Carrusel de productos: flechas + ocultarlas al llegar a los extremos */
(function () {
  function initRail() {
    document.querySelectorAll('.fk-rail-wrap').forEach(function (w) {
      if (w.dataset.fkRailReady) return;
      var rail = w.querySelector('.fk-prods-rail');
      if (!rail) return;
      w.dataset.fkRailReady = '1';
      var prev = w.querySelector('.fk-rail-prev'), next = w.querySelector('.fk-rail-next');
      function step(dir) {
        var card = rail.querySelector('.fk-prod');
        var d = card ? card.getBoundingClientRect().width + 16 : 260;
        rail.scrollBy({ left: dir * d * 2, behavior: 'smooth' });
      }
      w.querySelectorAll('[data-fk-rail]').forEach(function (b) {
        b.addEventListener('click', function () { step(parseInt(b.dataset.fkRail, 10)); });
      });
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.hidden = rail.scrollLeft <= 2;
        if (next) next.hidden = rail.scrollLeft >= max;
      }
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      /* Autoplay: avanza una tarjeta cada 2 s; al llegar al final vuelve al inicio.
         Se pausa al pasar el ratón o tocar, y al usar las flechas. Respeta reduce-motion. */
      var timer = null;
      function advance() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (rail.scrollLeft >= max) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          var card = rail.querySelector('.fk-prod');
          var d = card ? card.getBoundingClientRect().width + 16 : 260;
          rail.scrollBy({ left: d, behavior: 'smooth' });
        }
      }
      function play() {
        if (!timer && rail.scrollWidth > rail.clientWidth + 4) timer = setInterval(advance, 2000);
      }
      function pause() { if (timer) { clearInterval(timer); timer = null; } }
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        w.addEventListener('mouseenter', pause);
        w.addEventListener('mouseleave', play);
        w.addEventListener('touchstart', pause, { passive: true });
        w.querySelectorAll('[data-fk-rail]').forEach(function (b) {
          b.addEventListener('click', function () { pause(); setTimeout(play, 4000); });
        });
        play();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRail);
  else initRail();
  document.addEventListener('shopify:section:load', initRail);
})();
